import React from 'react';
import { Star } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Testimonials = () => {
  const { language } = useLanguage();
  
  // Single real student testimonial
  const studentReview = {
    name: language === 'ar' ? 'أحمد محمد' : 'Ahmad Mohammad',
    role: language === 'ar' ? 'طالب دورة C++' : 'C++ Course Student',
    text: language === 'ar' 
      ? 'الدورة ممتازة والمدرس محترف جداً. تعلمت C++ من الصفر وأصبحت أفهم البرمجة بشكل أفضل. أنصح بالدورة بقوة!'
      : 'Excellent course with a very professional instructor. I learned C++ from scratch and now understand programming much better. Highly recommend!'
  };

  return (
    <section id="testimonials" className="py-20" style={{ backgroundColor: 'var(--bg-section)' }}>
      <div className="container max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            {language === 'ar' ? 'رأي طلابنا' : 'What Our Student Says'}
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            {language === 'ar' 
              ? 'تجربة حقيقية من طالب التحق بدورة البرمجة معنا'
              : 'Real experience from our C++ programming course student'
            }
          </p>
        </div>
        
        {/* Single Student Review */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 border border-gray-200 dark:border-gray-700 shadow-lg">
            {/* Rating Stars */}
            <div className="flex justify-center gap-1 mb-6">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            
            <blockquote className="text-xl text-gray-600 dark:text-gray-300 text-center mb-8 italic leading-relaxed">
              "{studentReview.text}"
            </blockquote>
            
            <div className="flex items-center justify-center gap-4">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-blue-600 text-white rounded-full flex items-center justify-center font-bold text-xl">
                {studentReview.name.charAt(0)}
              </div>
              <div className="text-center">
                <div className="text-lg font-semibold text-gray-900 dark:text-white">
                  {studentReview.name}
                </div>
                <div className="text-gray-500 dark:text-gray-400">
                  {studentReview.role}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Overall Rating - Updated for 1 student */}
        <div className="text-center mt-16">
          <div className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-6 max-w-sm mx-auto border border-gray-200 dark:border-gray-700">
            <div className="flex items-center justify-center gap-2 mb-3">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white mb-1">4.5/5</div>
            <div className="text-gray-500 dark:text-gray-400 text-sm">
              {language === 'ar' ? 'تقييم من طالب واحد' : 'Rating from 1 student'}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;